import { jsx as _jsx } from "react/jsx-runtime";
// Side-effect import: shims new google-protobuf v4 reader/writer methods that
// the regenerated stubs call onto the v3 runtime currently shipped. Must
// precede any proto serialisation/deserialisation in the bundle.
import './services/protobufRuntimePolyfill';
import React from 'react';
import { createRoot } from 'react-dom/client';
import { PostHogProvider } from '@posthog/react';
import App from './App';
import { initializePostHog, posthog } from './services/posthogService';
import { captureEntryAttribution } from './utils/entryAttribution';
initializePostHog();
captureEntryAttribution();
const container = document.getElementById('root');
if (!container) {
    throw new Error('Failed to find the root element');
}
const root = createRoot(container);
root.render(_jsx(React.StrictMode, { children: _jsx(PostHogProvider, { client: posthog, children: _jsx(App, {}) }) }));
